import { Component } from '@angular/core';
import { Location } from '@angular/common';
import {  Router } from '@angular/router';
import { PageacessrightserviceService } from './pageacessrightservice.service';
import { Utilityservice } from '../views/utility/utilityservice.service';


@Component({
  selector: 'app-pagenotaccessright',
  templateUrl: './pagenotaccessright.component.html',
  styleUrls: ['./pagenotaccessright.component.css']
})
export class PagenotaccessrightComponent {
  currentUrl='';previousUrl=''
   constructor(private pageaccessservice: PageacessrightserviceService,private router:Router,private location: Location,
    private utilityservice:Utilityservice
   ) {
   
  }


goBack() {
   const attemptedUrl = this.pageaccessservice.getRedirectUrl();
   console.log(attemptedUrl,"attemptedUrl");
   

  if (attemptedUrl) {
    this.pageaccessservice.clearRedirectUrl();
    this.router.navigateByUrl(attemptedUrl);
  } else if (window.history.length > 1) {
this.location.back()  // prev ? this.router.navigateByUrl(prev) : this.router.navigateByUrl('/audit');
}
else{
   this.router.navigateByUrl('/audit')
}
}
  logout(){
this.utilityservice.logoutAndRedirect();


  }

}
